import $ from 'jquery';
import { View } from 'backbone';
import template from 'common-views/shared-properties.ejs';
import propertyViewMapService from 'PropertyViewMapService.js';
import formModel 		from 'formModel.js'
import focusController      from 'FocusController';

class SharedSettingsModalView extends View {
    initialize(opts) {
        this.options = opts || {};


        return this;
    }

    loadViews() {
        // Get Properties For Shared View
        var views = [];

        this.layout = formModel.get('currentDevice');
        var fKey = this.model.get('altFactoryKey') || this.model.get('factoryKey');

        if (this.layout === 'deviceTablet') {
            // Render Property Views
            views = propertyViewMapService.getSharedTabletSettings( fKey );
        }

        if (this.layout === 'devicePhone') {
            // Render Property Views
            views = propertyViewMapService.getSharedPhoneSettings( fKey );
        }


        if (views) {
            views.map( v => {
                var obj = new v.view({model: this.model, el: $(v.el), config: v.config });
                obj.render();
            });
        }
    }

    render() {
        this.$el.html(template(this.model.toJSON()));
        $('body').append(this.$el);


        let self = this;
        // Show modal popup window
        const dialog = $( '#shared-settings-dialog' ).dialog({
           // dialogClass: "no-close",
            autoOpen: true,
            height: 625,
            width: 800,
            modal: true,
            resizable: false,
            buttons: [
                {
                    text: 'Apply',
                    'class':'btn-applySharedProperties',
                    click: function() {
                        //self.saveItems();
                        // returning the selection to the control
                        focusController.selectionRectangle( self.model.get('id') );
                        dialog.dialog( "close" );
                        //eventBus.trigger('commonGroupUpdated');
                    }
                },
                {
                    text: 'Cancel',
                    'class':'btn-cancel',
                    click: function() {
                        dialog.dialog( "close" );
                    }
                }
            ],
            close: function() {
                dialog.dialog("destroy");
                $( '#shared-settings-dialog').remove();
            },
            open: () =>{
                self.loadViews();
            }
        });

        $('div[role="dialog"]').draggable({containment: 'body', scroll: false});

        this.delegateEvents();
        return this;
    }

}
export default SharedSettingsModalView;